import {doc, FirestoreDataConverter, getDoc, collection, query, where, getDocs} from "firebase/firestore";
import {db} from "@/main";

const wishPeriodConverter: FirestoreDataConverter<WishPeriod> = {
    toFirestore(data: WishPeriod) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            endDate: data.endDate.toDate(),
            startDate: data.startDate.toDate(),
            lastUpdate: data.lastUpdate?.toDate(),
            deadline: data.deadline?.toDate(),
        } as WishPeriod;
    }
};

export function GetWishPeriod(wishPeriodId: string): Promise<WishPeriod> {
    return new Promise<WishPeriod>((resolve, reject) => {
        const wishPeriodRef = doc(db, "wishPeriods", wishPeriodId).withConverter(wishPeriodConverter);
        getDoc(wishPeriodRef)
            .then((doc) => {
                if (doc.exists()) {
                    resolve(doc.data() as WishPeriod);
                } else {
                    reject("No wishPeriod found!");
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function GetWishPeriodsData(): Promise<WishPeriod[]> {
    return new Promise<WishPeriod[]>(async (resolve, reject) => {
        try {
            const wishPeriodsRef = collection(db, "wishPeriods").withConverter(wishPeriodConverter);

            const wishPeriodsDataQuery = query(
                wishPeriodsRef,
                where("hidden", "==", false)
            );

            const wishPeriodsDataSnapshot = await getDocs(wishPeriodsDataQuery);

            if (!wishPeriodsDataSnapshot.empty) {
                
                const returnWishPeriodsData: WishPeriod[] = [];
                for (const wishPeriodsData of wishPeriodsDataSnapshot.docs) {
                    returnWishPeriodsData.push({...wishPeriodsData.data(), dates: []} as WishPeriod);
                }
                resolve(returnWishPeriodsData);

            } else {
                reject("No matching wishPeriods found!");
            }
        } catch (error) {
            reject(error);
        }
    })}